import { Component, OnInit, Input } from '@angular/core';
import { Investor } from '../../shared/models/investor';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.css']
})
export class BalanceComponent implements OnInit {
  @Input()
  investor: Investor;
  @Input() flags: any;
  maxInvestableSIPAmount: number;
  maxInvestableLiquidFinancialAssetsAmount: number;
  maxInvestableOtherAssetsAmount: number;
  annualInvestingSIPAmount: number;

  constructor() { }

  ngOnInit() {
    this.maxInvestableSIPAmount = this.investor.total_investing_SIP_amount;
    this.maxInvestableLiquidFinancialAssetsAmount = Math.round(this.investor.total_liquid_financial_assets_value) || 0;
    this.maxInvestableOtherAssetsAmount = Math.round(this.investor.total_other_assets_value) || 0;
    this.investor.total_liquid_financial_assets_investing_value = this.maxInvestableLiquidFinancialAssetsAmount;

    this.investor.total_other_assets_investing_value = this.maxInvestableOtherAssetsAmount * 0.3;

    this.annualInvestingSIPAmount = this.investor.total_investing_SIP_amount * 12;
  }
  updateMonthlyToAnnual(monthly: Boolean){
    if(monthly){
      this.annualInvestingSIPAmount = this.investor.total_investing_SIP_amount * 12;
    } else {
      this.investor.total_investing_SIP_amount = Math.round(this.annualInvestingSIPAmount/12);
    }
  }
  updateUI(a) {

  }
  getTotalEmergencyFunds() {
    return this.investor.total_salary_professional_income * 6 || 0;
  }
  getOpeningBalance() {
    this.investor.total_opening_balance = (this.investor.total_investing_SIP_amount || 0) + (this.getFractionalTotalAssetsValue() || 0);
    return this.investor.total_opening_balance;
  }

  getFractionalTotalAssetsValue() {
    return (this.investor.total_liquid_financial_assets_investing_value + this.investor.total_other_assets_investing_value) || 0;
  }

  getMonthlySurplusAmount() {
    return Math.round(this.investor.total_investing_SIP_amount / 12) || '';
  }
  getMonthlyFinancialAssetsAmount() {
    return Math.round(this.investor.total_liquid_financial_assets_value / 12) || '';
  }
  getMonthlyOtherAssetsAmount() {
    return Math.round(this.investor.total_other_assets_value / 12) || '';
  }

  getTotalSourceAmount() {
    return (this.investor.total_investing_SIP_amount || 0 + this.investor.total_liquid_financial_assets_value || 0 + this.investor.total_other_assets_value || 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/balance/balance.component.ts